import { business } from '../data/business';
import { images } from '../data/images';
import type { Copy, Lang } from '../types/copy';

export function buildSchema(t: Copy, lang: Lang) {
  const base = business.url;
  const businessId = `${base}/#business`;
  const personId = `${base}/#pia`;

  const localBusiness = {
    '@type': ['LocalBusiness', 'HealthAndBeautyBusiness'],
    '@id': businessId,
    name: business.name,
    description: t.seo.description,
    url: base,
    telephone: business.phoneDisplay,
    email: business.email,
    image: images.hero,
    priceRange: '$$$',
    inLanguage: lang,
    knowsLanguage: ['en', 'es'],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'New York',
      addressRegion: 'NY',
      addressCountry: 'US',
    },
    areaServed: { '@type': 'City', name: 'New York City' },
    founder: { '@id': personId },
    sameAs: [business.instagram],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: t.services.title,
      itemListElement: t.services.items.map((s) => ({
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: s.title,
          description: s.description,
          serviceType: s.label,
          areaServed: 'New York City',
          provider: { '@id': businessId },
        },
      })),
    },
  };

  const person = {
    '@type': 'Person',
    '@id': personId,
    name: 'Pia',
    jobTitle: t.instructor.role,
    knowsLanguage: ['en', 'es'],
    worksFor: { '@id': businessId },
    alumniOf: { '@type': 'Organization', name: 'Sampoorna Yoga' },
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'certification',
      name: '200-hour Yoga Teacher Training (RYT-200)',
      recognizedBy: { '@type': 'Organization', name: 'Yoga Alliance' },
    },
    image: images.instructor,
  };

  const faq = {
    '@type': 'FAQPage',
    mainEntity: t.faq.items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };

  const crumbs = [
    { name: business.name, url: base },
    { name: t.nav.services, url: `${base}/#services` },
    { name: t.nav.about, url: `${base}/#about` },
    { name: t.nav.philosophy, url: `${base}/#philosophy` },
    { name: t.nav.faq, url: `${base}/#faq` },
    { name: t.nav.contact, url: `${base}/#contact` },
  ];

  const breadcrumbs = {
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: c.url,
    })),
  };

  return {
    '@context': 'https://schema.org',
    '@graph': [localBusiness, person, faq, breadcrumbs],
  };
}
